var map = {
	"./de/authentication.json": 15418,
	"./de/collections.json": 12381,
	"./de/common.json": 89532,
	"./de/errors.json": 51942,
	"./de/faqs.json": 8229,
	"./de/footer.json": 40659,
	"./de/forms.json": 72375,
	"./de/inspiration.json": 18746,
	"./de/magazine.json": 87161,
	"./de/menu.json": 27282,
	"./de/my-revigres.json": 89205,
	"./de/products.json": 34604,
	"./de/projects.json": 32416,
	"./de/recommend.json": 74436,
	"./de/stores.json": 83403,
	"./en/authentication.json": 33799,
	"./en/collections.json": 2433,
	"./en/common.json": 88332,
	"./en/errors.json": 22520,
	"./en/faqs.json": 77858,
	"./en/footer.json": 32094,
	"./en/forms.json": 58268,
	"./en/inspiration.json": 63244,
	"./en/magazine.json": 26326,
	"./en/menu.json": 59145,
	"./en/my-revigres.json": 75893,
	"./en/products.json": 47569,
	"./en/projects.json": 47305,
	"./en/recommend.json": 60615,
	"./en/stores.json": 84729,
	"./es/authentication.json": 16889,
	"./es/collections.json": 29537,
	"./es/common.json": 21212,
	"./es/errors.json": 53395,
	"./es/faqs.json": 77077,
	"./es/footer.json": 56281,
	"./es/forms.json": 7210,
	"./es/inspiration.json": 27382,
	"./es/magazine.json": 64770,
	"./es/menu.json": 36131,
	"./es/my-revigres.json": 85993,
	"./es/products.json": 87082,
	"./es/projects.json": 31111,
	"./es/recommend.json": 64143,
	"./es/stores.json": 562,
	"./fr/authentication.json": 35545,
	"./fr/collections.json": 86683,
	"./fr/common.json": 83868,
	"./fr/errors.json": 65714,
	"./fr/faqs.json": 72476,
	"./fr/footer.json": 78191,
	"./fr/forms.json": 99339,
	"./fr/inspiration.json": 39925,
	"./fr/magazine.json": 69543,
	"./fr/menu.json": 49890,
	"./fr/my-revigres.json": 40632,
	"./fr/products.json": 31107,
	"./fr/projects.json": 85328,
	"./fr/recommend.json": 7385,
	"./fr/stores.json": 60225,
	"./pt/authentication.json": 51649,
	"./pt/collections.json": 43238,
	"./pt/common.json": 57692,
	"./pt/errors.json": 91573,
	"./pt/faqs.json": 72270,
	"./pt/footer.json": 33091,
	"./pt/forms.json": 81157,
	"./pt/inspiration.json": 66827,
	"./pt/magazine.json": 79952,
	"./pt/menu.json": 78079,
	"./pt/my-revigres.json": 60328,
	"./pt/products.json": 4699,
	"./pt/projects.json": 81711,
	"./pt/recommend.json": 52854,
	"./pt/stores.json": 8478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34001;